/*
 * Size Chart Unit Switcher (IN <-> CM)
 * --------------------------------------------------
 * Size charts are authored in INCHES. INCHES is the default; shoppers switch
 * to CM with the toggle.
 *
 * Two table shapes are handled automatically:
 *   1. Table has BOTH unit columns ("Poitrine (pouces)" + "Poitrine (cm)"):
 *      -> just show one unit's columns and hide the other's. No maths.
 *   2. Table has only inch column(s):
 *      -> convert those numbers live (inch x 2.54, rounded) when CM is picked,
 *         and relabel the column header from inches to cm.
 *
 * Columns with no unit in their header (Taille, EU, ...) always stay visible.
 * Add data-no-convert to a <table> to leave it completely untouched.
 *
 * Unit detection is by header text, multilingual:
 *   cm -> "cm" / "centim"
 *   in -> "pouce" (fr) / "inch" / "zoll" (de) / "pollic" (it) / "(in" / quotes
 */
(function () {
  if (window.__scUnitSwitchInit) return;
  window.__scUnitSwitchInit = true;

  var CM_PER_IN = 2.54;
  var CM_KEYS = ['cm', 'centim'];
  var IN_KEYS = ['pouce', 'inch', 'zoll', 'pollic', '(in', '"', '”', '″'];
  var IN_WORD_RE = /pouces?|inches|inch|zoll|pollici|pollice/gi;

  function headerUnit(text) {
    var t = (text || '').toLowerCase();
    for (var i = 0; i < CM_KEYS.length; i++) {
      if (t.indexOf(CM_KEYS[i]) > -1) return 'cm';
    }
    for (var j = 0; j < IN_KEYS.length; j++) {
      if (t.indexOf(IN_KEYS[j]) > -1) return 'in';
    }
    return null;
  }

  function getHeaderRow(table) {
    return table.querySelector('thead tr') || table.querySelector('tr');
  }

  function getBodyRows(table) {
    var headerRow = getHeaderRow(table);
    return Array.prototype.filter.call(table.querySelectorAll('tr'), function (r) {
      return r !== headerRow;
    });
  }

  function analyzeTable(table) {
    var headerRow = getHeaderRow(table);
    var headers = headerRow ? headerRow.children : [];
    var inCols = [];
    var cmCols = [];
    for (var i = 0; i < headers.length; i++) {
      var unit = headerUnit(headers[i].textContent);
      if (unit === 'in') inCols.push(i);
      else if (unit === 'cm') cmCols.push(i);
    }
    return { inCols: inCols, cmCols: cmCols, headerRow: headerRow };
  }

  function setColumnsDisplay(table, colIndexes, show) {
    if (!colIndexes.length) return;
    table.querySelectorAll('tr').forEach(function (row) {
      colIndexes.forEach(function (ci) {
        var cell = row.children[ci];
        if (cell) cell.style.display = show ? '' : 'none';
      });
    });
  }

  function inchesToCm(text) {
    return text.replace(/\d+(?:[.,]\d+)?/g, function (token) {
      var n = parseFloat(token.replace(',', '.'));
      if (isNaN(n)) return token;
      return String(Math.round(n * CM_PER_IN));
    });
  }

  // Convert the numeric values of a cell, preserving its markup.
  function convertCellValues(td, toCm) {
    if (!td.__scOrigNodes) {
      td.__scOrigNodes = [];
      var walker = document.createTreeWalker(td, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        td.__scOrigNodes.push({ node: node, text: node.nodeValue });
      }
    }
    td.__scOrigNodes.forEach(function (rec) {
      rec.node.nodeValue = toCm ? inchesToCm(rec.text) : rec.text;
    });
  }

  // Relabel an inch column header to cm (and back).
  function relabelHeader(cell, toCm) {
    if (!('scHdr' in cell.dataset)) cell.dataset.scHdr = cell.innerHTML;
    cell.innerHTML = toCm
      ? cell.dataset.scHdr.replace(IN_WORD_RE, 'cm')
      : cell.dataset.scHdr;
  }

  function convertInchColumns(table, info, toCm) {
    getBodyRows(table).forEach(function (row) {
      info.inCols.forEach(function (ci) {
        var cell = row.children[ci];
        if (cell) convertCellValues(cell, toCm);
      });
    });
    if (info.headerRow) {
      info.inCols.forEach(function (ci) {
        var hcell = info.headerRow.children[ci];
        if (hcell) relabelHeader(hcell, toCm);
      });
    }
  }

  function setUnit(root, unit) {
    var toCm = unit === 'cm';
    root.querySelectorAll('table').forEach(function (table) {
      if (table.hasAttribute('data-no-convert')) return;
      var info = table.__scInfo || (table.__scInfo = analyzeTable(table));
      if (info.inCols.length && info.cmCols.length) {
        // Both unit columns present -> show one, hide the other.
        setColumnsDisplay(table, info.inCols, !toCm);
        setColumnsDisplay(table, info.cmCols, toCm);
      } else if (info.inCols.length) {
        // Inch-only table -> convert the inch columns.
        convertInchColumns(table, info, toCm);
      }
      // No recognised unit columns -> leave the table as-is.
    });
    root.querySelectorAll('.sc-unit-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.scUnit === unit);
    });
    root.setAttribute('data-active-unit', unit);
  }

  function initRoot(root) {
    if (!root) return;
    var unit = root.getAttribute('data-default-unit') || 'in';
    setUnit(root, unit);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // 1) Unit button clicked -> switch units
    var btn = e.target.closest('.sc-unit-btn');
    if (btn) {
      e.preventDefault();
      var root = btn.closest('.sc-size-chart');
      if (root) setUnit(root, btn.dataset.scUnit);
      return;
    }

    // 2) Size-guide trigger clicked -> popup opens, apply default unit (IN).
    //    Retry briefly until the table is in the DOM so the default shows from
    //    the first paint.
    var trigger = e.target.closest('[data-custom-class="size_chart"]');
    if (trigger) {
      var tries = 0;
      (function waitForChart() {
        tries++;
        var root =
          document.querySelector('.tingle-modal--visible .sc-size-chart') ||
          document.querySelector('.sc-size-chart');
        if (root && root.querySelector('table')) {
          initRoot(root);
        } else if (tries < 30) {
          setTimeout(waitForChart, 50);
        }
      })();
    }
  });
})();
